import React, { useState } from "react";
import { Container } from "reactstrap";
import All from "./All/All";
import Active from "./Active/Active";
import Deactivated from "./Deactivated/Deactivated";
import Ended from "./Ended/Ended";
import styles from './Management.module.scss';

const Management = () => {
  const tabs = ["All", "Active", "Deactivated", "Ended"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  return (
    <div className={styles.managementMainContainer}>
      <Container fluid className="p-0">
        <h4 className="fw-semibold mb-3">Advertisement Campaign Management</h4>

        <div className={styles.campaignWrapper}>
          <div className={styles.filterTabs}>
            {tabs.map((tab, index) => (
              <div
                key={index}
                className="fw-medium"
                style={{
                  color: tab === activeTab ? "#EC7426" : "black",
                  cursor: "pointer",
                  transition: "color 0.3s ease",
                  fontSize: "1.25rem",
                  padding: "0.5rem 1rem",
                }}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>

          {activeTab === "All" && <All />}
          {activeTab === "Active" && <Active />}
          {activeTab === "Deactivated" && <Deactivated />}
          {activeTab === "Ended" && <Ended />}

        </div>
      </Container>
    </div>
  );
};

export default Management;